<template>
  <div
    v-if="shown"
    class="modal-backdrop"
  >
    <div
      class="modal fade show d-block overflow-auto"
      @click="$emit('close')"
    >
      <div
        class="modal-dialog"
        :class="size && `modal-${size}`"
        @click.stop
      >
        <div class="modal-content">
          <div class="modal-body">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    shown: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-content {
  border: 0;
  border-radius: 18px;
  box-shadow: 0 15px 15px -10px rgba(0, 0, 0, 0.25);

  .btn {
    min-width: 152px;
  }
}
</style>
